// extracted by mini-css-extract-plugin
export default {"modal":"UserInstructionsModal_modal__RHZMl","markdown":"UserInstructionsModal_markdown__N63fp"};